import { render } from "./PageNotFound.vue?vue&type=template&id=5c72eb61&scoped=true"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"

import "./PageNotFound.vue?vue&type=style&index=0&id=5c72eb61&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c72eb61"]])

export default __exports__